import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { paths } from '@constants/paths';
import { BASKET_RETRIEVAL_TOKEN } from '@constants/queryParams';
import { BASKET_ID_KEY } from '@constants/storageKeys';
import { useBasketContext } from '@providers/basket/BasketProvider/Context';
import { useLocalSessionAddressContext } from '@providers/basket/LocalSessionAddressProvider/Context';

const getLocalStorageBasketId = () =>
  window.localStorage.getItem(BASKET_ID_KEY);

const useOldSession = () => {
  const { basketId, setBasketId, handleStartAgain } = useBasketContext();
  const { handleAddressPageState } = useLocalSessionAddressContext();
  const [hasOldSession, setHasOldSession] = useState(false);
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const isRestoringFromUrl = params.get(BASKET_RETRIEVAL_TOKEN);

  useEffect(() => {
    setHasOldSession(
      !basketId && !!getLocalStorageBasketId() && !isRestoringFromUrl
    );
  }, [basketId, isRestoringFromUrl]);

  const handleRestoreOldSession = () => {
    setBasketId(getLocalStorageBasketId() as string);
    // After session resumes, this loads address page input
    handleAddressPageState();
    navigate(paths.bundle);
  };

  const handleRejectOldSession = () => {
    handleStartAgain();
    setHasOldSession(false);
  };

  return {
    hasOldSession,
    handleRejectOldSession,
    handleRestoreOldSession,
    localBasketId: getLocalStorageBasketId(),
  };
};

export { useOldSession };
